<template>
  <div class="identificationCardType">
    <div class="verification-form">
      <div class="form-item" v-if="idTypeAadhar">
        <div class="insert-image" v-if="!frontAadharPreview">
          <label class="file">
          <span class="material-icons video-icons">video_camera_front</span>
          <div class="file-custom">
            <input
              type="file"
              id="addharFront"
              ref="myFiles"
              accept="video/*"
              @change="uploadFrontAadhar"
              multiple
            />
            <span class="upload_photo">वीडियो बनाएं</span>
            </div>
          </label>
        </div>
        <div class="insert-image" v-if="frontAadharPreview">
          <label class="file">
          <img :src="frontAadharPreview" :alt="frontAadharPreview" />
          <div class="file-custom">
            <input
              type="file"
              id="shopVideo2"
              ref="myFiles"
              accept="video/*"
              @change="uploadFrontAadhar"
              multiple
            />
            </div>
          </label>
        </div>
      </div>
      <div class="form-item" v-if="idTypeOthers">
        <div class="insert-image" v-if="!otherIdentityCardPreview">
          <label class="file">
          <span class="material-icons video-icons">photo_camera</span>
          <div class="file-custom">
            <input
              type="file"
              id="file"
              ref="myFiles"
              accept="image/*"
              @change="uploadIdentityCard"
              multiple
            />
            <span class="upload_photo">सेल्फी क्लिक करें</span>
            </div>
          </label>
        </div>
        <div class="insert-image" v-if="otherIdentityCardPreview">
          <label class="file">
          <img :src="otherIdentityCardPreview" :alt="otherIdentityCardPreview" />
          <div class="file-custom">
            <input
              type="file"
              id="shopPhotofile"
              ref="myFiles"
              accept="image/*"
              @change="uploadIdentityCard"
              multiple
            />
            </div>
          </label>
        </div>
      </div>
      
    </div>
  </div>
</template>
<script>
import axios from "axios";
import constant from "../../utils/constant";
import { uploadImageFile,getBase64Url } from "../../utils/helper";

export default {
  name: "IdentificationCardType",
  components: {
  
  },
  props: {
    getDocumentDetail:{
      type: Array
    },
    selectedIdCardType: {
        type: String
    }
  },
  data() {
    return {
      shopSelfiePreview: '',
      shopSelfieFile: [],
      shopVideoPreview:'',
      shopVideoFile: [],
      gstNumber: null,
      getDocument: {},
      identificationCardType: [
        {name: 'AADHAAR_CARD', value: 'Aadhar Card'},
        {name: 'PASSPORT', value: 'Passport'},
        {name: 'PAN_CARD', value: 'PanCard'},
        {name: 'DRIVING_LICENSE', value: 'Driving License'},
        {name: 'RATION_CARD', value: 'Ration card'},
        {name: 'VOTER_ID', value: 'Voter Id'},
      ]

    }
  },

  computed: {
  },

  mounted() {
    
  },

  methods: {
    async uploadVideo(file){
      const image = file.target.files[0];
      if (!image.type.includes("video/")) {
        alert("Please select an image file");
        return;
      }
      getBase64Url(image).then(data => {
        this.shopVideoPreview= data;
      });
      const formData = new FormData();
      this.loading = true;
      formData.append("image", image, image.name);
      formData.append("isResizeRequired", true);
      await axios
        .post(constant.FILE_UPLOAD_URL_OLD, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(data => {
          this.shopVideoFile = data.data.mediaVariantDTOs[0].url;
          this.loading = false;
        })
        .catch(err => {
          console.log("FAILURE", err);
        });
    },
    async uploadPhoto(file) {
      const image = file.target.files[0];
      if (!image.type.includes("image/")) {
        alert("Please select an image file");
        return;
      }
      getBase64Url(image).then(data => {
        this.shopSelfiePreview= data;
      });
      const formData = new FormData();
      this.loading = true;
      formData.append("image", image, image.name);
      formData.append("isResizeRequired", true);
      await axios
        .post(constant.FILE_UPLOAD_URL_OLD, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(data => {
          this.shopSelfieFile = data.data.mediaVariantDTOs[0].url;
          this.loading = false;
        })
        .catch(err => {
          console.log("FAILURE", err);
        });
    },
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/verification-form.scss";
</style>
